<template>
  <div class="login-layout" :class="{ 'login-layout--dark': $vuetify.theme.dark }">
    <div class="new-flex" v-if="loginMode === 'signup'">
      <div>
        <v-layout>
          <v-img height="60" contain :src="loginLogo"></v-img>
        </v-layout>
        <div class="mx-auto mt-10"><!-- elevation-8 -->
          <v-card-text class="pa-0">
            <v-layout column>
              <v-card flat class=" card-box">
                <v-form ref="loginForm" autocomplete="off" class="mt-3">
                  <v-text-field v-model="model.username" outlined dense append-icon="mdi-account"
                    @keyup.enter="loginHandler" :rules="$_requiredValidation" id="username_field"
                    :label="$t('message.login.userName')" type="text" hide-details class="mb-3"
                    ref="usernameField"></v-text-field>
                  <v-text-field v-model="model.password" outlined dense id="password_field" :rules="$_requiredValidation"
                    :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'" @keyup.enter="loginHandler"
                    :label="$t('message.login.password')" :type="showPassword ? 'text' : 'password'"
                    @click:append="showPassword = !showPassword" hide-details class="mb-3" autocomplete="new-password"></v-text-field>
                  <v-text-field v-model="hostRef" @keyup="doAlphaNumericConversion" outlined dense
                                @keyup.enter="loginHandler" id="domain" :rules="$_requiredValidation"
                                :label="$t('message.login.host')" type="text" :suffix="defaultHostTld" :hide-details="!domainHasMistake"
                                class="mb-3"></v-text-field>
                  <v-select append-icon="mdi-translate" id="lang_select" outlined dense hide-details
                    :label="$t('message.login.language')" :items="language" v-model="defaultLang" item-text="title"
                    item-value="value"></v-select>
                  <v-layout>
                    <span class="mt-2" :style="{ cursor: 'pointer', color: '#3773e8' , fontSize: '16px' }" @click="forgotPasswordClick">{{ $t('message.login.forgotPassword') }} </span>
                  </v-layout>
                  <v-layout justify-center class="mt-5">
                    <v-btn class="button-deign" :loading="loading" @click="loginHandler">{{$t('message.layout.login') }}</v-btn>
                  </v-layout>
                  <v-layout justify-center>
                    <p class="my-3">{{ $t('message.layout.ortext') }}</p>
                  </v-layout>
                  <v-layout justify-center @click="rfidClick">
                    <v-btn class="button-deign">
                      {{ $t('message.layout.rfidsignin') }}
                    </v-btn>
                  </v-layout>
                </v-form>
              </v-card>
            </v-layout>
          </v-card-text>
        </div>
      </div>
    </div>
    <div class="new-flex" v-if="loginMode === 'rfid'">
      <div>
        <v-layout>
          <v-img height="60" contain :src="loginLogo"></v-img>
        </v-layout>
        <div class="mx-auto mt-10"><!-- elevation-8 -->
          <v-card-text class="pa-0">
            <v-layout column>
              <v-card flat class=" card-box">
                <v-form ref="rfidform" autocomplete="off" class="mt-3">
                  <v-text-field v-model="from.password" :rules="$_requiredValidation" outlined dense id="password_field"
                    :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'" :label="$t('message.layout.ScanRFID')"
                    :type="showPassword ? 'text' : 'password'" @click:append="showPassword = !showPassword" hide-details
                    class="mb-3" @keyup.enter="rfidHandler" ref="passwordField"></v-text-field>
                  <v-text-field v-model="hostRef" :rules="$_requiredValidation" @keyup="doAlphaNumericConversion" outlined dense
                                @keyup.enter="rfidHandler" id="domain" :label="$t('message.login.host')" type="text"
                                :suffix="defaultHostTld" :hide-details="!domainHasMistake" class="mb-3"></v-text-field>
                  <v-select append-icon="mdi-translate" id="lang_select" outlined dense hide-details
                    :label="$t('message.login.language')" :items="language" v-model="defaultLang" item-text="title"
                    item-value="value"></v-select>
                  <v-layout justify-center @click="signInPassword" class="mt-5">
                    <v-btn class="button-deign">
                      {{ $t('message.layout.SignInpassword') }}
                    </v-btn>
                  </v-layout>
                </v-form>
              </v-card>
            </v-layout>
          </v-card-text>
        </div>
      </div>
    </div>
    <div class="new-flex" v-if="loginMode === 'forgot password'">
      <div>
        <v-layout>
          <v-img height="60" contain :src="loginLogo"></v-img>
        </v-layout>
        <div class="mx-auto mt-10">
          <v-card>
            <v-card-title class="text-center justify-center">{{ $t('message.login.forgotPassword') }}</v-card-title>
            <v-card-subtitle class="text-center">{{ $t('message.login.forgotPasswordHint') }}</v-card-subtitle>
            <v-card-text>
              <v-form ref="forgotPasswordForm" @submit.prevent>
                <v-text-field ref="forgotPasswordEmailField" class="mt-1 mb-3" v-model="forgotPasswordEmail" :rules="$_requiredValidation" outlined dense
                              :label="$t('message.login.emailAddress')" type="email" hide-details></v-text-field>
                <v-text-field v-model="hostRef" @keyup="doAlphaNumericConversion" outlined dense
                  @keyup.enter="loginHandler" id="domain" :rules="$_requiredValidation"
                  :label="$t('message.login.host')" type="text" :suffix="defaultHostTld" :hide-details="!domainHasMistake"
                  class="mb-3"></v-text-field>
                <v-btn class="button-deign" :loading="loading" type="submit" @click="forgotPasswordHandler">{{ $t('message.login.resetMyPassword') }}</v-btn>
                <v-card-actions>
                  <span class="mt-2" :style="{ cursor: 'pointer', fontSize: '15px'}" @click="signInPassword">{{ $t('message.login.backToLogin') }}</span>
                </v-card-actions>
              </v-form>
            </v-card-text>
          </v-card>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { LOGIN, LOGIN_RFID, FORGOT_PASSWORD } from '@/store/actionsTypes'
export default {
  data () {
    return {
      loading: false,
      model: {
        username: '',
        password: ''
      },
      from: {
        password: ''
      },
      hostRef: '',
      defaultLang: window.localStorage.getItem(process.env.VUE_APP_LOCALE_STORAGE) ? window.localStorage.getItem(process.env.VUE_APP_LOCALE_STORAGE) : 'no',
      showPassword: false,
      logoUrl: process.env.VUE_APP_LOGO_FILE_NAME,
      domainHasMistake: false,
      forgotPasswordEmail: '',
      loginMode: 'signup' // 'signup' | 'rfid' | 'forgot password'
    }
  },
  computed: {
    // swap to the dark logo in dark mode (matches HeaderLogo), else the configured logo
    loginLogo () {
      return this.$vuetify.theme.dark
        ? require('../../assets/darkmode_logo.png')
        : require(`../../assets/${this.logoUrl}`)
    },
    language () {
      return [
        { title: this.$t('message.common.english'), value: 'en' },
        { title: this.$t('message.common.norwegian'), value: 'no' },
        { title: this.$t('message.common.lithuanian'), value: 'lt' },
        { title: this.$t('message.common.polish'), value: 'pl' },
        { title: this.$t('message.common.swedish'), value: 'sv' }
      ]
    },
    $_domainValidation () {
      return [
        val => {
          if (!val) {
            this.domainHasMistake = true
            return 'Required'
          }
          if (val.match(/^[0-9a-zA-Z]+$/)) {
            this.domainHasMistake = false
            return true
          } else {
            this.domainHasMistake = true
            return 'Invalid Domain Name'
          }
        }]
    },
    defaultHostTld () {
      return process.env.VUE_APP_STORE_HOST_DOMAIN
    },
    host () {
      const hostRef = this.hostRef.toLowerCase().replace(/[^0-9a-z]/g, '')

      if (!hostRef.includes(this.defaultHostTld)) {
        return `${hostRef}${this.defaultHostTld}`
      }

      return hostRef
    }
  },
  watch: {
    defaultLang () {
      this.$i18n.locale = this.defaultLang
      window.localStorage.setItem(process.env.VUE_APP_LOCALE_STORAGE, this.defaultLang)
    }
  },
  created () {
    this.hostRef = window.localStorage.getItem(process.env.VUE_APP_DOMAIN_CACHE_NAME) ?? ''
  },
  methods: {
    doAlphaNumericConversion () {
      this.hostRef = this.hostRef.substring(0, 13).replace(/[^A-Za-z1-9]/g, '')
    },
    loginHandler () {
      if (!this.$refs.loginForm.validate()) {
        this.$root.$emit('snackbar', { snackbar: true, color: 'error', text: 'message.common.validationIssue' })
        return
      }

      window.localStorage.removeItem('TimerPwa_weekno')
      window.localStorage.removeItem('TimerPwa_year')

      this.loading = true

      this.$store
        .dispatch(LOGIN, {
          host: this.host,
          tenant: this.hostRef,
          email: this.model.username,
          password: this.model.password
        })
        .then(() => this.$store.dispatch('getGeneralSettings'))
        .then((generalSettings) => {
          const redirectTo = {
            1: '/calendar',
            2: '/stemp',
            3: '/dashboard'
          }[generalSettings.timer_startup ?? 3]
          if (this.$route.fullPath !== redirectTo) {
            this.$router.push(redirectTo).catch(() => {})
          }
        })
        .catch((e) => {
          this.$root.$emit('snackbar', { snackbar: true, color: 'error', text: this.$t(e.message) })
        })
        .finally(() => {
          this.loading = false
        })
    },
    rfidHandler () {
      if (!this.$refs.rfidform.validate()) {
        this.$root.$emit('snackbar', { snackbar: true, color: 'error', text: 'message.common.validationIssue' })
        return
      }

      window.localStorage.removeItem('TimerPwa_weekno')
      window.localStorage.removeItem('TimerPwa_year')

      this.loading = true

      this.$store
        .dispatch(LOGIN_RFID, {
          host: this.host,
          tenant: this.hostRef,
          rfid: this.from.password
        })
        .then(() => this.$store.dispatch('getGeneralSettings'))
        .then((generalSettings) => {
          const redirectTo = {
            1: '/calendar',
            2: '/stemp',
            3: '/dashboard'
          }[generalSettings.timer_startup ?? 3]
          if (this.$route.fullPath !== redirectTo) {
            this.$router.push(redirectTo).catch(() => {})
          }
        })
        .catch((e) => {
          this.$root.$emit('snackbar', { snackbar: true, color: 'error', text: this.$t(e.message) })
        })
        .finally(() => {
          this.loading = false
        })
    },
    rfidClick () {
      this.loginMode = 'rfid'
      this.$nextTick(() => {
        this.$refs.passwordField.$refs.input.focus()
      })
    },
    signInPassword () {
      this.loginMode = 'signup'
      this.$nextTick(() => {
        this.$refs.usernameField.$refs.input.focus()
      })
    },
    forgotPasswordClick () {
      this.loginMode = 'forgot password'
      this.$nextTick(() => {
        this.$refs.forgotPasswordEmailField.$refs.input.focus()
      })
    },
    forgotPasswordHandler () {
      if (!this.$refs.forgotPasswordForm.validate()) {
        this.$root.$emit('snackbar', { snackbar: true, color: 'error', text: 'message.common.validationIssue' })
        return
      }

      this.$store.dispatch(FORGOT_PASSWORD, {
        host: this.host,
        email: this.forgotPasswordEmail
      }).then((res) => {
        this.$root.$emit('snackbar', { snackbar: true, color: 'success', text: res.message })
        this.forgotPasswordEmail = ''
        this.signInPassword()
      }).catch((e) => {
        this.$root.$emit('snackbar', { snackbar: true, color: 'error', text: this.$t(e.message) })
      })
    }
  }
}
</script>

<style>
.border-styles {
  border-top-right-radius: 40px !important;
  border-bottom-left-radius: 40px !important;
}

.login .v-sheet--offset {
  top: -30px;
  position: relative;
}

.login-layout {
  position: fixed;
  background-color: #EEF1F5;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  justify-content: center;
}
/* dark mode: match the app's dark page background (#0b1019) */
.login-layout--dark {
  background-color: #0b1019;
}

.new-flex {
  display: flex;
  justify-content: center;
  flex-direction: column;
  height: 100%;
  max-width: 500px;
  padding: 0 15px;
}
@media only screen and (max-width: 575px) {
  .new-flex {
    max-width: 100%;
  }
}

.card-box {
  padding: 30px 25px !important;
  border-radius: 10px !important;
  background-color: #ffffff !important;
}
/* dark mode: the login card uses the app's dark surface (#16202e) */
.login-layout--dark .card-box {
  background-color: #16202e !important;
}

.button-deign {
  width: 100%;
  padding: 14px 20px !important;
  border-radius: 18px !important;
  background-color: #3773e8 !important;
  height: unset !important;
}

.button-deign span {
  color: #fff;
}
</style>
